import React from "react";
import { Button } from "antd";
import UserTrackOrder from "../../components/tables/UserTrackOrder";

const TrackOrderPage = () => {
	return (
		<>
			<UserTrackOrder button={Button} />
		</>
	);
};

export default TrackOrderPage;
